// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"2af93cb2596872aa76c2","655":"4ee2189b1052883f7053"}[chunkId] + ".js";
};